<template>
  <div
      class="m-1 p-0 text-green-600 hover:text-black focus:outline-none focus:ring-1 focus:ring-green-600"
  >
    <svg
        viewBox="0 0 23 23"
        class="w-4 h-4"
        fill="none"
        stroke-width="3"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path stroke-linecap="round" stroke-linejoin="round"
              d="M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5"></path>
    </svg>
  </div>
</template>
<script setup lang="ts">
</script>
